export default __webpack_public_path__ + "OrbitControls-859183169460bb6933ed60cc02c50a48.js";